import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ImpersonateHandler = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const token = searchParams.get('token');

        if (token) {
            // Salva o token no localStorage
            localStorage.setItem('token', token);

            // Marca que está em modo impersonate
            localStorage.setItem('isImpersonating', 'true');

            // Redireciona para o dashboard
            navigate('/dashboard', { replace: true });
        } else {
            // Se não houver token, redireciona para login
            navigate('/signin', { replace: true });
        }
    }, [searchParams, navigate]);

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <div className="text-center">
                <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
                <p className="mt-4 text-gray-600">Autenticando como administrador...</p>
            </div>
        </div>
    );
};

export default ImpersonateHandler;
